import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AssignmentTable } from '../../../../components/shared/tables/AssignmentTable';
import { RecipeCandidateDto } from '../../../../app/services/api/range';

interface MenuRecipesTabProps {
  recipes: RecipeCandidateDto[];
  isLoading: boolean;
  assignedRecipeIds: ReadonlySet<number>;
  originalAssignedRecipeIds: ReadonlySet<number>;
  onToggle: (recipeId: number) => void;
  readOnly?: boolean;
}

export const getMenuRecipeSearchText = (recipe: RecipeCandidateDto): string => (
  String(recipe.recipeName ?? '')
);

const MenuRecipesTab = ({ recipes, isLoading, assignedRecipeIds, originalAssignedRecipeIds, onToggle, readOnly = false }: MenuRecipesTabProps) => {
  const { t } = useTranslation('range');

  return (
    <Box>
      <AssignmentTable<RecipeCandidateDto>
        title={t('recipes')}
        items={recipes}
        getRowId={(row) => row.recipeId}
        getSearchableText={getMenuRecipeSearchText}
        assignedIds={assignedRecipeIds}
        originalAssignedIds={originalAssignedRecipeIds}
        onToggle={onToggle}
        readOnly={readOnly}
        loading={isLoading}
        pageSize={10}
        searchPlaceholder={t('searchPlaceholder')}
        emptyMessage={t('noRecipesFound')}
        columns={[
          { id: 'recipeName', label: t('recipeName'), render: (row) => row.recipeName || t('notSet') },
          { id: 'category', label: t('category'), render: (row) => row.category || t('notSet') },
        ]}
      />
    </Box>
  );
};

export default MenuRecipesTab;
